// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-message-menu-button .message-options-menu-trigger .mat-icon {
  font-size: 19px;
}

.fi-message-action-menu.mat-mdc-menu-panel {
  min-width: 150px;
}
.fi-message-action-menu.mat-mdc-menu-panel .mat-mdc-menu-item.delete-button .message-action-label,
.fi-message-action-menu.mat-mdc-menu-panel .mat-mdc-menu-item.delete-button .mat-icon {
  color: var(--fi-color-error-message);
}
.fi-message-action-menu.mat-mdc-menu-panel .mat-mdc-menu-item .mat-icon {
  color: #77777a;
  line-height: 24px;
  margin-right: 16px;
  text-align: center;
}
.fi-message-action-menu.mat-mdc-menu-panel .mat-mdc-menu-item .message-action-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--fi-color-steel-grey);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation/fi-chat-conversation-message/message-menu-button/message-menu-button.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;;AAIA;EACI,gBAAA;AADJ;AAKY;;EAEI,oCAAA;AAHhB;AAOQ;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AALZ;AAQQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iCAAA;AANZ","sourcesContent":[".fi-message-menu-button {\r\n    .message-options-menu-trigger .mat-icon {\r\n        font-size: 19px;\r\n    }\r\n}\r\n\r\n.fi-message-action-menu.mat-mdc-menu-panel {\r\n    min-width: 150px;\r\n\r\n    .mat-mdc-menu-item {\r\n        &.delete-button {\r\n            .message-action-label,\r\n            .mat-icon {\r\n                color: var(--fi-color-error-message);\r\n            }\r\n        }\r\n\r\n        .mat-icon {\r\n            color: #77777a;\r\n            line-height: 24px;\r\n            margin-right: 16px;\r\n            text-align: center;\r\n        }\r\n\r\n        .message-action-label {\r\n            font-weight: 400;\r\n            font-size: 14px;\r\n            line-height: 20px;\r\n            letter-spacing: 0.25px;\r\n            color: var(--fi-color-steel-grey);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
